export default {
  summary_one: '{{count}} articolo rimosso · non disponibile per il tuo orario di ritiro',
  summary_other: '{{count}} articoli rimossi · non disponibili per il tuo orario di ritiro',
  reason: 'Ordinabile solo {{schedule}} — il tuo ritiro è alle {{time}}.',
  change_pickup_time: 'Cambia orario di ritiro',
  dismiss: 'Ignora',
};
